import type { FaireProductEntity } from "../../entity_types/product";

export const p_by97hq2w5y: FaireProductEntity = {
  token: "p_by97hq2w5y",
  type: "product",
  name: "Warm Desert Gold Drink Coasters",
  brandToken: "b_2t1ui5ps",
  brandName: "Paper Anchor Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/686896ac551f4113e2769eff12dc23aadbc7ea3e8fb4d5c1df814b429cca4a75.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6aebf3b0f407c9b875da255d9655e71dacd7f96069e20b8159b81b1ed74f3cf6.jpeg",
    "https://cdn.faire.com/fastly/dfe7d7a4e5b3e48b13f8ed3eb7bd2e1a2475684c56a20961b336a6787f1fb6a4.jpeg",
    "https://cdn.faire.com/fastly/c95eb25fdd0f0965dd379913be88c07df9aafc9f561e19d0a83a1c05a4c74dbb.jpeg",
    "https://cdn.faire.com/fastly/311952d5711c3577f4c91b36e6b554092aeb96dc310ca13d9f63171e9f105419.jpeg",
  ],
  priceDollars: 9,
  description:
    "Plated in 18k gold, our desert-inspired coasters are designed to be more than a resting place for your glass — they are mini masterpieces that anchor you in the here and now. Inspired by the quiet revel of nature, each piece transforms an everyday ritual into a small moment of art and awe. Whether shared over coffee, cocktails or cozy evenings at home, these coasters invite you to slow down, savor, and surround yourself with beauty.\n\nGIFTING IDEAS:\nPerfect gift for birthdays, housewarmings or simply to surprise any plant lover. These cute coasters are ideal for any tabletop as home decor, bar cart or desk accessory. They’re a unique gift under $25, and are sure to brighten up any drinkware with a one-of-a-kind nature-inspired decorative object. Also ideal for Holiday and Christmas gifts, stocking stuffers, or that extra special present under the tree.\n\n- Individual coaster \n- 3.5 in. diameter\n- 18k gold plated\n- Soft enamel\n- Polish with a dry cloth, not dishwasher safe\n- Rubber feet to eliminate tabletop scratches\n\nPlease note that there may be slight imperfections in the metal or enamel of each coaster.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:20:54.792Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
